import { useAdaptiveWidth } from '@/hooks/useAdaptiveWidth';
import { useEnhancedRouter } from '@/hooks/useEnhancedRouter';
import { setShowSidebar } from '@/store';
import { BuyButtonLink } from '@/types';
import { pixelRunScript } from '@/utils/pixelRunScript';
import cn from 'classnames';
import { useDispatch } from 'react-redux';
import styles from './BuyTicket.module.scss';

export function BuyTicket({
  links,
  text = 'Купить билет',
}: {
  links: BuyButtonLink[];
  text?: string;
}) {
  const { isTablet } = useAdaptiveWidth();
  const { push, asPath } = useEnhancedRouter();
  const currentPath = asPath.split('?')[0];

  const dispatch = useDispatch();

  const getButtonLink = (
    currentPath: string,
    links: BuyButtonLink[],
  ): string => {
    const link = links.find((link) => link.path === currentPath);
    return link ? link.buyPath : '/tickets';
  };

  const getButtonMetrics = (
    currentPath: string,
    links: BuyButtonLink[],
  ): string => {
    const link = links.find((link) => link.path === currentPath);
    return link ? link.vkId : 'buy-ticket';
  };

  const buttonLink = getButtonLink(currentPath, links);

  const buttonMetrics = getButtonMetrics(currentPath, links);

  const handleButtonClick = () => {
    pixelRunScript(buttonMetrics);
    dispatch(setShowSidebar(false));
    push(buttonLink);
  };

  if (isTablet)
    return (
      <div className={styles.wrapper}>
        <div className={cn(styles.button, 'custom-buy-ticket-button')}>
          <img
            loading="lazy"
            src="/svg/ticket.svg"
            width={24}
            height={24}
            alt="buy-ticket"
            onClick={handleButtonClick}
          />
        </div>
      </div>
    );

  return (
    <div className={styles.container} onClick={handleButtonClick}>
      <img
        src="/svg/buy.svg"
        alt="buy-ticket"
        className={styles.buy}
        loading="lazy"
      />
      <span className={styles.text}>{text}</span>
    </div>
  );
}
